import axios from 'axios';
import { MDBBtn, MDBCard, MDBCardBody, MDBCol, MDBContainer, MDBInput, MDBRow, MDBSelect, MDBTextArea } from "mdb-react-ui-kit";
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import AddressView from "../../address/AddressView";
import { DomainContext } from '../../context/DomainProvider';
import { UserProfileContext } from '../../context/UserProfileProvider';
import EmailView from '../../email/EmailView';
import ImageUpload from '../../image/ImageUpload';
import PhoneView from '../../phones/PhoneView';
import { fetchUserProfile } from '../../utils/Common';
import ForgotPassword from '../ForgotPassword';
function UserProfile({ showLoginModal, setShowUserProfileModal, showUserProfileModal, user, isCheckout }) {
  const { setDomainData } = useContext(DomainContext);
  const [, setIsSubmitted] = useState(false);
  const { setAddresses, setPhones, setEmails, userProfile, setUserProfile, setUid, setGroups, groups, setRoles, tokenLoaded,titles,setTitles } = useContext(UserProfileContext);
  const [title, setTitle] = useState(user?.title || userProfile?.title);
  const [firstName, setFirstName] = useState(user?.firstName || userProfile?.firstName);
  const [lastName, setLastName] = useState(user?.lastName || userProfile?.lastName);
 
  const [description, setDescription] = useState(user?.description || userProfile?.description);
  const baseUrl = process.env.REACT_APP_INVENTORY_URL;




  useEffect(() => {
    const fetchData = async () => {
      await fetchUserProfile(setUserProfile, setUid, setAddresses, setEmails, setPhones, tokenLoaded, setGroups, setRoles,setTitles);
    };
    if (tokenLoaded) {
      fetchData();
    }
  }, [setAddresses, setEmails, setGroups, setPhones, setUid, setUserProfile, tokenLoaded]);


  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Format the groups properly before sending to the server
    const formattedGroups = userProfile.groups?.map(group => ({
      groupName: group.groupName || "", // Provide default values if necessary
      groupDn: group.groupDn || "",
      users: group.users || [],
      subGroups: group.subGroups || []
    }));
  
    const updatedFields = {
      firstName: firstName,
      lastName: lastName,
      description: description,
      title: title,
      groups: formattedGroups, // Ensure groups are sent in the correct structure
      uid: user ? user.uid : userProfile.uid,
      ou: user ? user.ou : userProfile.ou
    };
  
    try {
      const response = await axios.put(`${baseUrl}/userprofiles`, updatedFields);
      console.log("Response:", response);
      if (response && response.data) {
        // Update domain data in state
        setDomainData(prevState => {
          const updatedUsers = prevState.users?.map(user => {
            if (user.uid === updatedFields.uid) {
              return response.data;
            }
            return user;
          });
  
          return {
            ...prevState,
            users: updatedUsers,
          };
        });
  
        // Update user profile in state
        console.log("Before update:", user);
        const updatedUserProfile = {
          ...user,
          firstName: response.data.firstName,
          lastName: response.data.lastName,
          description: response.data.description,
          title: response.data.title,
          groups:response.data.groups,
          uid: response.data.uid,
        };
        console.log("After update:", response.data);
        setUserProfile(updatedUserProfile);
      }
      setShowUserProfileModal && setShowUserProfileModal(false);
    } catch (error) {
      console.error("Error updating user profile:", error);
    } finally {
      setIsSubmitted(true);
    }
  };
  

 
  const transformedTitles = (titles || []).map(title => ({
    text: title.charAt(0).toUpperCase() + title.slice(1),
    value: title,
  }));
  
  // Ensure the current userProfile.title is included in transformedTitles
  if (userProfile?.title && !transformedTitles.some(item => item.value === userProfile.title)) {
    transformedTitles.push({
      text: userProfile.title.charAt(0).toUpperCase() + userProfile.title.slice(1),
      value: userProfile.title,
    });
  }
  
  
  
  return (
    <>{(user || userProfile) &&
      <MDBContainer className="mb-2 position-relative grainy-gradient-intro justify-content-center text-center">
        <div className='d-flex mb-2'>
          {showUserProfileModal && <MDBBtn className='ms-auto' size='sm' color='light' onClick={() => setShowUserProfileModal(false)}>x</MDBBtn>}
        </div>

        {/* Profile Image Upload Section */}

        {/* User Profile Form Section */}
        <MDBContainer className="mb-2">
          <h5 className="display-8 fw-bold text-blue mb-0 text-center" style={{ letterSpacing: '1px' }}>USER</h5>
          <hr className="hr" />
          <MDBRow className="d-flex">
            {!isCheckout && (
              <MDBCol sm='12' md='4' lg='6'>
                <div className='text-center rounded mt-3'>
                  <ImageUpload
                    baseUrl={baseUrl}
                    pictureId={user ? user.picture || '' : (userProfile?.picture)}
                    user={user || userProfile}
                    setShowUserProfileModal={setShowUserProfileModal}
                  />
                </div>
              </MDBCol>
            )}

            {/* User Info Card */}
            <MDBCol sm='12' md='4' lg='6'>
              <MDBCard className='text-center rounded mt-3'>
                <MDBCardBody>
                  <div className="mb-3">
                    <strong>{user ? user.uid : userProfile.uid} @ {user ? user.myDomainName : userProfile.myDomainName}</strong>
                  </div>
                  <form>
                    <MDBInput
                      className="mb-4"
                      label="First Name *"
                      name="firstName"
                      //value={user ? user.firstName : userProfile.firstName}
                      value={firstName}
                      //   onChange={(e) => setUserProfile({ ...userProfile, firstName: e.target.value })}
                      onChange={(e) => { setFirstName(e.target.value) }}
                      required
                    />
                    <MDBInput
                      className="mb-4"
                      label="Last Name *"
                      name="lastName"
                      value={lastName}

                      onChange={(e) => { setLastName(e.target.value) }}
                      required
                    />
                    {title === 'admin' ?
                      <>  <MDBSelect
                        responsive={true}
                        className="mb-4"
                        wrapperClass="custom-dropdown"
                        label="Title"
                        value={userProfile?.title}
                        data={transformedTitles}
                        search
                        onValueChange={(value) => {
                          const selectedValue = value?.value || ''; // Extract the selected value
                       
                          setUserProfile((prev) => ({ ...prev, title: selectedValue })); // Update the userProfile title
                        }}
                      />

{/* <MDBSelect 
                        responsive={true}
                        className="mb-4"
                        wrapperClass="custom-dropdown"
                        label="Roles"
                        value={roles} multiple 
                        data={transformedRoles}
                        search
                        onValueChange={(value) => setRoles(value?.value || '')}
                      /> */}
<MDBSelect
  responsive
  className="mb-4"
  wrapperClass="custom-dropdown"
  label="Group"
  data={groups} // Array of { text: groupName, value: groupDn }
  search
  value={userProfile.groups?.map((group) => group.groupDn)} // Pre-select based on groupDn
  multiple
  onValueChange={(selectedValues) => {
    setUserProfile((prev) => ({
      ...prev,
      groups: selectedValues.map((item) => ({
        groupName: item.text, // Use the label from the dropdown
        groupDn: item.value, // Use the value (DN) from the dropdown
        users: [], // Initialize users (or populate if required)
        subGroups: [], // Initialize subGroups (or populate if required)
      })),
    }));
  }}
/>


                      </> :

                      <>
                        <MDBInput
                          className="mb-4"
                          label="Title"
                          name="title"
                          value={title}

                          disabled
                        />


                        <MDBInput
                          className="mb-4"
                          label="Group"
                          name="group"
                          value={userProfile?.group}

                          disabled
                        />
                      </>
                    }

                    {!isCheckout && (
                      <MDBTextArea
                        rows={4}
                        className="mb-4 mt-4"
                        label="Description *"
                        name="description"
                        value={description}

                        onChange={(e) => { setDescription(e.target.value) }}
                        required
                      />
                    )}
                    <div className="d-flex justify-content-center">
                      <MDBBtn type="submit" onClick={handleSubmit}>Update</MDBBtn>
                    </div>
                  </form>
                </MDBCardBody>
              </MDBCard>
              {!isCheckout && <ForgotPassword existingUser={userProfile} showLoginModal={showLoginModal} />}
            </MDBCol>

            {/* Address, Phone, and Email Views */}
            <MDBCol sm='12' md='4' lg='6'>
              <AddressView isCheckout={isCheckout} />
            </MDBCol>
            <MDBCol sm='12' md='4' lg='6'>
              <PhoneView isCheckout={isCheckout} />
              <EmailView isCheckout={isCheckout} />
            </MDBCol>

          </MDBRow>
        </MDBContainer>

        {/* Forgot Password Section */}

      </MDBContainer>
    }
    </>
  );
}

UserProfile.propTypes = {
  showLoginModal: PropTypes.bool,
  setShowUserProfileModal: PropTypes.func,
  showUserProfileModal: PropTypes.bool,
  user: PropTypes.object,
  isCheckout: PropTypes.bool,
}

export default UserProfile;
